(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-2"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.h2Init === 'true') return;
    root.dataset.h2Init = 'true';

    var threshold = parseInt(root.getAttribute('data-scroll-threshold') || '10', 10);
    var toggle = root.querySelector('[data-h2-toggle]');
    var open = false;
    var scrolled = false;

    function apply() {
      root.classList.toggle('is-open', open);
      root.classList.toggle('is-scrolled', scrolled && !open);
      document.body.style.overflow = open ? 'hidden' : '';
      if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    function onScroll() {
      scrolled = window.scrollY > threshold;
      apply();
    }

    if (toggle) {
      toggle.addEventListener('click', function () {
        open = !open;
        apply();
      });
    }

    // Close the menu when a link inside the overlay is tapped.
    var overlay = root.querySelector('.header-2__overlay');
    if (overlay) {
      overlay.addEventListener('click', function (e) {
        if (e.target.closest('a')) {
          open = false;
          apply();
        }
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function boot() {
    document.querySelectorAll('[data-h2-root]').forEach(init);
  }

  if (document.readyState !== 'loading') {
    boot();
  } else {
    document.addEventListener('DOMContentLoaded', boot);
  }

  // Theme editor support
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:unload', function () {
    document.body.style.overflow = '';
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
